import HttpClient from "libs/utils/HttpClient";

class FileService {
  async getFile(fileId) {
    try {
      const response = await HttpClient.getBlob(
        `/api/file/getfile?FileID=${fileId}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadFile({ file, Status, fileID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("Status", Status);

      if (fileID) {
        formData.append("FileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/file/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadFileDoc({ file, Status, fileID, logBookID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("Status", Status);
      formData.append("logBookID", logBookID);

      if (fileID) {
        formData.append("FileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/file/doc/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadFileImageDepartment({ file, Status, departmentId }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("Status", Status);

      if (departmentId) {
        formData.append("departmentId", departmentId);
      }

      const response = await HttpClient.post(
        `/api/file/department/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // async getEducationFile(educationId) {
  //   try {
  //     const response = await HttpClient.getBlob(
  //       `/api/file/education/getfile?educationId=${educationId}`
  //     );
  //     return response;
  //   } catch (error) {
  //     const newError = error;
  //     throw newError;
  //   }
  // }
  // async getProcessfileID(processfileID) {
  //   try {
  //     const response = await HttpClient.getBlob(
  //       `/api/file/process/getfile?processfileID=${processfileID}`
  //     );
  //     return response;
  //   } catch (error) {
  //     const newError = error;
  //     throw newError;
  //   }
  // }

  // async getPassportFile(personalID) {
  //   try {
  //     const response = await HttpClient.getBlob(
  //       `/api/file/passport/getfile?personalID=${personalID}`
  //     );
  //     return response;
  //   } catch (error) {
  //     const newError = error;
  //     throw newError;
  //   }
  // }

  // async getDocumentFile(uploadfileID) {
  //   try {
  //     const response = await HttpClient.getBlob(
  //       `/api/file/document/getfile?uploadfileID=${uploadfileID}`
  //     );
  //     return response;
  //   } catch (error) {
  //     const newError = error;
  //     throw newError;
  //   }
  // }
}

export default new FileService();
